import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ConditionTypeOfTransactionListResponse } from '@modules/creatives-link/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  CREATIVES_LINK_PERMISSIONS,
  LOAD_CONDITION_TYPE_OF_TRANSACTION_API_URL,
  LOAD_CONDITION_TYPE_OF_TRANSACTION_QUERY_KEY,
} from '@modules/creatives-link/constants';

export default function useConditionTypeOfTransactionListQuery(
  merchant: Ref<number | undefined>,
): IContextQueryResult<ConditionTypeOfTransactionListResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ConditionTypeOfTransactionListResponse>({
    queryKey: [LOAD_CONDITION_TYPE_OF_TRANSACTION_QUERY_KEY, merchant],
    queryFn: ({ signal }) => fetchGet<ConditionTypeOfTransactionListResponse>(
      LOAD_CONDITION_TYPE_OF_TRANSACTION_API_URL,
      {
        signal,
        permission: CREATIVES_LINK_PERMISSIONS.SHOW,
        queryParams: {
          merchant: merchant.value,
        },
      },
    ),
    gcTime: 0,
    enabled: computed(() => !!merchant.value),
  });
}
